import React, { useState, useEffect, useCallback } from 'react'
import { useSnackbar } from 'notistack'
import DynamicTable from '../../components/DataTables/DynamicTable'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import FormModal from '../../components/General/FormModal'
import Spiner from '../../components/General/Spiner'
import { styled } from '@mui/material/styles'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const Tableros = () => {
  const [spiner, setSpiner] = useState(false)
  const [isOpenModalform, setIsOpenModalForm] = useState(false)
  const [dataTableroForm, setDataTableroForm] = useState([])
  const { enqueueSnackbar } = useSnackbar()
  const [saveType, setSaveType] = useState('I')
  const [header, setHeader] = useState('I')
  const [tableroId, setTableroId] = useState(0)
  const [data, setdata] = useState([])
  const [totalRows, setTotalRows] = useState(0)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)

  const getTableros = useCallback(async (idTablero, page, perPage, search = "") => {
    setSpiner(true)
    const resp = await ConfiguracionLogic.tableroLogic(idTablero, page, perPage, search)
    if (resp.success) {
      setdata(resp.data)
      setTotalRows(resp.totalRows)
    }
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setSpiner(false)
  }, [enqueueSnackbar]);

  useEffect(() => {
    getTableros(0, 1, 5, '')
  }, [getTableros])

  const columns = ['Nombre', 'Descripcion']

  const handleNew = async () => {
    cleanStorage()
    setSaveType("I")
    setTableroId(0)
    setSpiner(true)
    setDataTableroForm([])
    setIsOpenModalForm(true)
    setSpiner(false)
    setHeader('Nuevo Tablero')
  }

  const cleanStorage = () => {
    localStorage.removeItem('name')
    localStorage.removeItem('description')
    localStorage.removeItem('url')
    localStorage.removeItem('area')
  }

  const handleCloseModal = () => {
    setIsOpenModalForm(false)
    cleanStorage()
  }

  const handledSave = async (event) => {
    event.preventDefault()
    setSpiner(true)
    const resp = await ConfiguracionLogic.saveEditTableroLogic(tableroId, event.target, saveType)
    enqueueSnackbar(resp.message, {
      variant: resp.variant,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right'
      }
    })
    setSpiner(false)
    if (saveType === 'I') {
      if (resp.success) {
        setIsOpenModalForm(false)
        cleanStorage()
      }
      setTimeout(function () {
        if (resp.success) {
          window.location = global.TABLERO
        }
      }, global.DELAY)
    } else {
      cleanStorage()
      setIsOpenModalForm(false)
      //const resp = await ConfiguracionLogic.tableroLogic(tableroId, 1, 5, '')
      //setDataTableroForm(resp)
      window.location.reload();
    }
  }

  const handleEdit = async (item) => {
    setSpiner(true)
    const resp = await ConfiguracionLogic.tableroLogic(item.id, 1, 5, '')
    setSaveType("E")
    setTableroId(item.id)
    setDataTableroForm(resp)
    setIsOpenModalForm(true)
    setSpiner(false)
    setHeader('Editar Tablero')
  }

  const handleDelete = (item) => {
    setSelectedItem(item)
    setOpenDeleteModal(true)
  }

  const confirmDelete = async () => {
    if (selectedItem) {
      const resp = await ConfiguracionLogic.saveEditTableroLogic(selectedItem, '', 'D')
      enqueueSnackbar(resp.message, {
        variant: resp.variant,
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      })
      setSpiner(false)
      if (saveType === 'I') {
        if (resp.success) {
          setIsOpenModalForm(false)
          cleanStorage()
        }
        setTimeout(function () {
          if (resp.success) {
            window.location = global.TABLERO
          }
        }, global.DELAY)
      } else {
        setIsOpenModalForm(false)
        window.location.reload();
      }
      setOpenDeleteModal(false)
    }
  }

  const cancelDelete = () => {
    setOpenDeleteModal(false)
  }

  const handleSearch = (item) => {
    getTableros(0, 1, 5, item)
    // Lógica para eliminar el elemento
  }

  const onLink = (item) => {
    localStorage.setItem('dahboardOnlInkId', item.id)
    localStorage.setItem('nombreOnlInkId', item.Nombre)
    window.location = global.TABLERO_LINK
  }

  const handlePageChange = (page, perPage) => {
    getTableros(0, page, perPage, '')
  }

  const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: '20px',
    marginLeft: theme.spacing(4),
    padding: theme.spacing(1, 4),
  }))

  return (

    <div className="content-wrapper">
      <Spiner opt={spiner} />
      <FormModal
        isOpen={isOpenModalform}
        handleCloseModal={handleCloseModal}
        header={header}
        button={'Guardar'}
        formData={dataTableroForm}
        handledSave={handledSave}
        opt={'tablero'}
        modalWith={'md'} // Puedes ajustar a 'xs', 'sm', 'lg', 'xl' según lo que necesites
      />

      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">Configuración</li>
                <li className="breadcrumb-item">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <br />
                <div className="card-body">
                  <DynamicTable
                    columns={columns}
                    data={data}
                    onNew={handleNew}
                    headerText="Nuevo Tablero"
                    onEdit={handleEdit}
                    onDelete={handleDelete}
                    onLink={onLink}
                    onSearch={handleSearch}
                    onPageChange={handlePageChange}
                    totalRows={totalRows}
                  />

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Dialog
        open={openDeleteModal}
        onClose={cancelDelete}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialogContent-root": {
            overflowY: "hidden", // Esto evitará la barra de desplazamiento
          },
          "& .MuiDialog-paper": {
            maxHeight: "400px", // Ajusta el tamaño máximo del modal si es necesario
          },
        }}
      >
        <DialogTitle>
          Confirmar Eliminación
          <IconButton
            edge="end"
            color="inherit"
            onClick={cancelDelete}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <p>¿Estás seguro que deseas eliminar este elemento?</p>
        </DialogContent>
        <DialogActions>
          <StyledButton onClick={cancelDelete} sx={{ backgroundColor: 'lightblue', color: 'blue', '&:hover': { backgroundColor: 'lightblue' } }}>
            Cancelar
          </StyledButton>
          <StyledButton onClick={confirmDelete} sx={{ backgroundColor: 'blue', color: 'white', '&:hover': { backgroundColor: 'darkblue' } }}>
            Confirmar
          </StyledButton>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default Tableros
